import ContactApi from '../../api/contactApi'

export default {
  state: {

  },
  mutations: {

  },
  actions: {
    CONTACT_CREATE(store, data) {
      return new Promise((resolve, reject) => {
        ContactApi.create(data).then(response => {
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        });
      })
    },
    CONTACT_UPDATE(store, p) {
      return new Promise((resolve, reject) => {
        ContactApi.update(p.id, p.data).then(response => {
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        });
      })
    },
    CONTACT_DELETE(store, id) {
      return new Promise((resolve, reject) => {
        ContactApi.delete(id).then(response => {
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        });
      })
    }
  }
}
